// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.gc-agency-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1f2937;
}

p.gc-agency-handle {
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
  width: 160px;
}

.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.gc-agency-img {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  color: #2d388b;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
  flex: 0 0 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.leftBoder-4 {
  border-left: 4px solid #0A6ED9 !important;
}

.episodeLeftBorder-4 {
  border-left: 4px solid #6ACE6A !important;
}

.gc-user-img {
  justify-self: start;
}

.submission-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.submission-poup-content {
  padding: 20px 24px;
}
.submission-poup-content .submission-card {
  background: #F6F8FF;
  border-radius: 16px;
  padding: 24px;
}
.submission-poup-content .submission-card .submission-details label {
  font-weight: 600;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  opacity: 0.5;
}
.submission-poup-content .submission-card .submission-details span {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
}
.submission-poup-content .submission-card .gc-submission-user {
  display: flex;
  align-items: center;
  gap: 13px;
}
.submission-poup-content .submission-card .gc-submission-user .SU-avatar {
  width: 68px;
  height: 68px;
  background: #E7ECF0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #000000;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info p {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #1F2937;
}
.submission-poup-content .submission-card .gc-submission-user .SU-info span {
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #4B5563;
  opacity: 0.5;
}
.submission-poup-content button.accept-btn {
  padding: 10px 12px;
  border: none;
  width: 119px;
  height: 40px;
  background: rgba(16, 185, 129, 0.1);
  border-radius: 6px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #10B981;
  cursor: pointer;
}
.submission-poup-content button.recheck-btn {
  width: 119px;
  height: 40px;
  background: rgba(251, 191, 36, 0.1);
  border-radius: 6px;
  border: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #FBBF24;
  cursor: pointer;
}

.btn-text {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #8F95B2;
  background: none;
  border: none;
  cursor: pointer;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #ECF0F5;
  gap: 24px;
}

.close-button {
  color: black;
  border: 1px solid black;
  background-color: white;
  gap: 24px;
}

.color {
  color: blue;
}

.custom-button {
  color: gray;
  border: none;
  text-decoration: none;
  background-color: transparent;
}

.custom-button:hover {
  text-decoration: underline;
}

.text-black {
  color: #1F2937;
}

.clearBtn {
  background: none;
  border: none;
  padding-right: 10px;
  cursor: pointer;
}

.dropzone {
  position: relative;
  height: 345px;
  width: 100%;
  border: 2px dashed #D1D5DB;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.dropzone input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}
.dropzone label {
  color: #1F2937 !important;
}
.dropzone label u {
  text-decoration: underline;
}

.fileupload-info {
  background: #f6f8ff;
  padding: 15px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.viewBy-filter {
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 0.5rem;
}

.align-name-fields {
  display: flex;
  gap: 1rem;
}

.opacity7 {
  opacity: 0.7;
}

.button-container {
  position: sticky;
  z-index: 999;
  bottom: 0;
  background: #fff;
}

/* Bulk-upload duplicate-handling dialog (IOHB-1713) */
.duplicate-mrn-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 150px;
  overflow-y: auto;
  margin-top: 4px;
}

.duplicate-mrn-chip {
  background: #eef2ff;
  color: #2d388b;
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
}

.duplicate-dialog-footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  /* .btn-cancel is a fixed 186px globally, which overflows a dialog footer
     holding three buttons — size the buttons to their content here instead. */
}
.duplicate-dialog-footer .btn-cancel,
.duplicate-dialog-footer .p-button {
  width: auto;
  min-width: 120px;
  height: 44px;
  padding: 0 18px;
  white-space: nowrap;
}

@media (max-width: 640px) {
  .duplicate-dialog-footer .btn-cancel,
  .duplicate-dialog-footer .p-button {
    width: 100%;
  }
}
::ng-deep .upload-company-dropdown,
::ng-deep .upload-template-dropdown {
  min-width: 220px;
}

.coordination-note-upload-btn {
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  flex: 0 0 auto !important;
}
.coordination-note-upload-btn ::ng-deep .p-button {
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/patient/patient.component.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;ADEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAGF;;AADA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,YAAA;AAIF;;AAFA;EACE,oBAAA;EACA,eAAA;EACA,YAAA;AAKF;;AAHA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,yCAAA;AAOF;;AALA;EACE,yCAAA;AAQF;;AANA;EACE,mBAAA;AASF;;AAPA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AAUF;;AARA;EACE,kBAAA;AAWF;AAVE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;AAYJ;AAVM;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAYR;AAVM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAYR;AATI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAWN;AAVM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAYR;AATQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAWV;AATQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;AAWV;AANE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAQJ;AANA;EACI,YAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAQJ;;AALA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAQF;;AANA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AASF;;AAPA;EACE,YAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAUF;;AARA;EACE,WAAA;AAWF;;AAVC;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,6BAAA;AAaF;;AAXA;EACE,0BAAA;AAcF;;AAZA;EACE,cAAA;AAeF;;AAbA;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAgBF;;AAdA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAiBF;AAfE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAiBJ;AAfE;EACE,yBAAA;AAiBJ;AAhBI;EACE,0BAAA;AAkBN;;AAdA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAiBF;;AAfA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;AAkBF;;AAhBA;EACE,aAAA;EACA,SAAA;AAmBF;;AAjBA;EACE,YAAA;AAoBF;;AAlBA;EACI,gBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AAqBJ;;AAnBA,sDAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AAsBF;;AApBA;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,SAAA;EAEA;8EAAA;AAwBF;AAtBE;;EAEE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAwBJ;;AArBA;EAEI;;IAEE,WAAA;EAuBJ;AACF;AAfA;;EAEE,gBAAA;AAiBF;;AAXA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EAIA,yBAAA;AAWF;AATE;EACE,mBAAA;AAWJ","sourcesContent":["\n@import \"../../assets/styles/colors.scss\";\n.gc-agency-name {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 16px;\n  color: #1f2937;\n}\np.gc-agency-handle {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 16px;\n  color: rgb(75 85 99 / 50%);\n  width: 160px;\n}\n.disabled {\n  pointer-events: none;\n  cursor: default;\n  opacity: 0.6;\n}\n.gc-agency-img {\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: #fff;\n  color: #2d388b;\n  text-align: center;\n  font-size: 25px;\n  font-weight: 600;\n  flex: 0 0 46px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.leftBoder-4 {\n  border-left: 4px solid $primaryBlue !important;\n}\n.episodeLeftBorder-4 {\n  border-left: 4px solid $Green !important;\n}\n.gc-user-img {\n  justify-self: start;\n}\n.submission-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.submission-poup-content {\n  padding: 20px 24px;\n  .submission-card{\n    background: #F6F8FF;\n    border-radius: 16px;\n    padding: 24px;\n    .submission-details{\n      label{\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 30px;\n        color: #4B5563;\n        opacity: 0.5;\n      }\n      span{\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 30px;\n        color: #1F2937;\n      }\n    }\n    .gc-submission-user{\n      display: flex;\n      align-items: center;\n      gap: 13px;\n      .SU-avatar{\n        width: 68px;\n        height: 68px;\n        background: #E7ECF0;\n        border-radius: 50%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-style: normal;\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 30px;\n        text-align: center;\n        color: #000000;\n      }\n      .SU-info{\n        p{\n          font-style: normal;\n          font-weight: 600;\n          font-size: 24px;\n          line-height: 30px;\n          color: #1F2937;\n        }\n        span{\n          font-style: italic;\n          font-weight: 500;\n          font-size: 16px;\n          line-height: 30px;\n          color: #4B5563;\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n  button.accept-btn {\n    padding: 10px 12px;\n    border: none;\n    width: 119px;\n    height: 40px;\n    background: rgba(16, 185, 129, 0.1);\n    border-radius: 6px;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: #10B981;\n    cursor: pointer;\n}\nbutton.recheck-btn {\n    width: 119px;\n    height: 40px;\n    background: rgba(251, 191, 36, 0.1);\n    border-radius: 6px;\n    border: none;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 20px;\n    color: #FBBF24;\n    cursor: pointer;\n  }\n}\n.btn-text{\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  color: #8F95B2;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 20px;\n  border-top: 1px solid #ECF0F5;\n  gap: 24px;\n}\n.close-button {\n  color: black;\n  border: 1px solid black;\n  background-color: white;\n  gap: 24px;\n}\n.color {\n  color : blue\n}.custom-button {\n  color: gray;\n  border: none;\n  text-decoration: none;\n  background-color: transparent;\n}\n.custom-button:hover {\n  text-decoration: underline;\n}\n.text-black{\n  color:#1F2937;\n}\n.clearBtn{\n  background: none;\n  border: none;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.dropzone {\n  position: relative;\n  height: 345px;\n  width: 100%;\n  border: 2px dashed #D1D5DB;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  // background: url(../../assets/images/fileupload.svg) no-repeat center center;\n  input{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    opacity: 0;\n  }\n  label{\n    color: #1F2937 !important;\n    u{\n      text-decoration: underline;\n    }\n  }\n}\n.fileupload-info{\n  background:#f6f8ff;\n  padding: 15px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n.viewBy-filter{\n  position: absolute;\n  top: 0;\n  left: 0;\n  padding-top: 0.5rem;\n}\n.align-name-fields {\n  display: flex;\n  gap: 1rem;\n}\n.opacity7 {\n  opacity: 0.7;\n}\n.button-container{\n    position: sticky;\n    z-index: 999;\n    bottom: 0;\n    background: #fff;\n}\n/* Bulk-upload duplicate-handling dialog (IOHB-1713) */\n.duplicate-mrn-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  max-height: 150px;\n  overflow-y: auto;\n  margin-top: 4px;\n}\n.duplicate-mrn-chip {\n  background: #eef2ff;\n  color: #2d388b;\n  border-radius: 12px;\n  padding: 2px 10px;\n  font-size: 12px;\n  line-height: 20px;\n  white-space: nowrap;\n}\n.duplicate-dialog-footer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 12px;\n\n  /* .btn-cancel is a fixed 186px globally, which overflows a dialog footer\n     holding three buttons — size the buttons to their content here instead. */\n  .btn-cancel,\n  .p-button {\n    width: auto;\n    min-width: 120px;\n    height: 44px;\n    padding: 0 18px;\n    white-space: nowrap;\n  }\n}\n@media (max-width: 640px) {\n  .duplicate-dialog-footer {\n    .btn-cancel,\n    .p-button {\n      width: 100%;\n    }\n  }\n}\n\n// Coordination note upload — Super/IOH admin company scoping (IOHB-NA).\n// Deliberately kept out of .bulkUpload-btn: that class carries many !important\n// width/height/label-hiding rules in styles.scss built for the split-button-style\n// \"Download Template\" dropdown, which would collapse a normal labeled dropdown.\n::ng-deep .upload-company-dropdown,\n::ng-deep .upload-template-dropdown {\n  min-width: 220px;\n}\n\n// The \"Upload Coordination Note\" button carries a longer label than \"Upload Bulk Patient\",\n// which .bulkUpload-btn's fixed 200px width (styles.scss) clips. Same modifier-class override\n// pattern as .download-library-btn there: let the button auto-size to its text.\n.coordination-note-upload-btn {\n  width: auto !important;\n  min-width: 0 !important;\n  max-width: none !important;\n  // .bulkUpload-btn also carries `flex: 0 0 195px !important` (styles.scss) for when it's\n  // itself a flex item — as it now is, inside the company/agency/upload row — which clamps\n  // this box before the width overrides above can take effect. Let it size to its children.\n  flex: 0 0 auto !important;\n\n  ::ng-deep .p-button {\n    white-space: nowrap;\n  }\n}\n","/**\n * Created by Inzamam Janjua on 18/05/2023.\n */\n\n\n// Primary Color Palette\n\n$primaryBlue: #0A6ED9;\n$GreenBlue: #1C75BC;\n$Orange: #EF896A;\n$DarkSilver: #6C6D70;\n$BrightYellow: #F9A51D;\n$Green: #6ACE6A;\n$Greenlight: #7AEC7A;\n$GreenDark: #5CB85C;\n$white: #fff;\n$black: #000;\n$red:#C66A9E;\n// Standard System Colors\n\n$errorRed: #FF3C3C;\n$darkRed: #C11574;\n$lightRed: #FDF2FA;\n$successGreen: #10B981;\n$lightGreen: #ECFAF5;\n$lightOrange: #FFF2EB;\n$notificationYellow: #F9A51D;\n$lightBlue:rgba(226, 238, 255, 1);\n$headingText: #1E38A9;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
